export default {
    namespaced: true,
    state: {
        cookieConsentRequired: false,
        isAuthenticated: false,
        accessToken: null,
        tokenType: null,
        participantId: null,
        role: null,
        firstname: null,
        lastname: null,
        email: null,
        passwordHash: null,
        accessDenied: false,
        gdprAccepted: false,
        showFirstLoginScreen: false,
        phone: null,
        organizationId: null,
        magicLoginToken: null,
        tokenConfirmed: null,
        forceLogin: null
    },
    mutations: {
        setUserData(state, data) {
            if (data) {
                state.accessToken = data.access_token;
                state.tokenType = data.token_type;
                state.participantId = data.participant_id;
                state.role = data.role;
                state.firstname = data.firstname;
                state.lastname = data.lastname;
                state.email = data.email;
                state.gdprAccepted = data.gdpr_accepted;
                state.isAuthenticated = true;
                state.phone = data.phone;
            } else {
                state.accessToken = null;
                state.tokenType = null;
                state.participantId = null;
                state.role = null;
                state.firstname = null;
                state.lastname = null;
                state.email = null;
                state.isAuthenticated = false;
                state.gdprAccepted = false;
                state.showFirstLoginScreen = false,
                state.phone = null;
            }
        },
        setUserInfo(state, data) {
            state.firstname = data.firstname;
            state.lastname = data.lastname;
            state.email = data.email;
        },
        setPasswordHash: (state, val) => state.passwordHash = val,
        setCookieRequired: (state, val) => state.cookieConsentRequired = val == true || val == 'true' ? 1 : 0,
        setAccessDenied: (state, val) => state.accessDenied = val,
        setGdprAccepted: (state, val) => state.gdprAccepted = val,
        setFirstLoginScreen: (state, val) => state.showFirstLoginScreen = val,
        setOrganizationId: (state, val) => state.organizationId = val,
        setMagicLoginToken: (state, val) => state.magicLoginToken = val,
        setTokenConfirmed: (state, val) => state.tokenConfirmed = val,
        setForceLogin: (state, val) => state.forceLogin = val,
    },
};
